<div class="settings-panel">
  <div class="panel-body">
    <form [formGroup]="form" class="settings-panel-form">
      <!-- LTI Configuration URL Section -->
      <div class="lti-config-url-section">
        <h3>{{ 'LTI Configuration URL' | translate }}</h3>
        <p class="config-url-description">
          {{ 'Use this URL when registering Pencil as an LTI provider in your LMS:' | translate }}
        </p>
        <div class="config-url-container">
          <input type="text" readonly [value]="ltiConfigurationUrl" class="config-url-input" />
          <app-pencil-button
            buttonType="button"
            theme="secondary-outline"
            icon="content_copy"
            [iconConfig]="{ type: IconTypes.matIcon, outlined: true }"
            [label]="'Copy' | translate"
            (clickEvent)="copyToClipboard(ltiConfigurationUrl)"
          >
          </app-pencil-button>
        </div>
      </div>

      <!-- LTI Configurations Section -->
      <div class="column-container section-container lti-configurations-container">
        <div class="section-title">
          {{ 'Active configurations' | translate }}
        </div>

        <!-- Add Configuration Button -->
        <div class="add-setting-container">
          <app-pencil-button
            buttonType="button"
            theme="secondary-outline"
            icon="add"
            [iconConfig]="{ type: IconTypes.matIcon }"
            [label]="'Add LTI Configuration' | translate"
            (clickEvent)="addLtiSetting()"
          >
          </app-pencil-button>
        </div>

        <!-- Empty State -->
        <div *ngIf="ltiSettingsArray.controls.length === 0" class="empty-state">
          <app-pencil-icon
            name="integration_instructions"
            [type]="IconTypes.materialIcon"
            [outlined]="true"
          ></app-pencil-icon>
          <div class="empty-state-title">{{ 'No LTI configurations yet' | translate }}</div>
          <div class="empty-state-description">
            {{
              'Add your first LTI configuration to start integrating with your Learning Management System.'
                | translate
            }}
          </div>
        </div>

        <div class="ltiSettings" formArrayName="ltiSettings">
          <div
            *ngFor="let settingGroup of ltiSettingsArray.controls; let i = index"
            [formGroupName]="i"
            class="lti-setting-group"
          >
            <div class="lti-setting-header">
              <h4>
                {{
                  settingGroup.get('name')?.value?.trim() ||
                    ('LTI Configuration {{index
                }}' | translate: { index: i + 1 }) }}
              </h4>
              <div class="header-actions">
                <app-pencil-button
                  buttonType="button"
                  theme="danger"
                  icon="delete_outline"
                  [iconConfig]="{ type: IconTypes.matIcon }"
                  [label]="'Remove' | translate"
                  (clickEvent)="removeLtiSetting(i)"
                >
                </app-pencil-button>
              </div>
            </div>

            <!-- Name Field (Full Width) -->
            <div class="form-row form-row-single">
              <div class="form-field">
                <div class="form-input-container">
                  <span class="label">{{ 'Configuration Name' | translate }}</span>
                  <input
                    type="text"
                    formControlName="name"
                    class="form-input"
                    [placeholder]="'Enter a name for this configuration' | translate"
                  />
                </div>
              </div>
            </div>

            <div class="form-row">
              <div class="form-field">
                <div class="form-input-container">
                  <span class="label">{{ 'Client ID' | translate }} *</span>
                  <input
                    type="text"
                    formControlName="client_id"
                    class="form-input"
                    [placeholder]="'Enter Client ID' | translate"
                    [class.invalid]="
                      settingGroup.get('client_id')?.invalid &&
                      settingGroup.get('client_id')?.touched
                    "
                  />
                </div>
                <span
                  class="error"
                  *ngIf="
                    settingGroup.get('client_id')?.invalid && settingGroup.get('client_id')?.touched
                  "
                >
                  <ng-container *ngIf="settingGroup.get('client_id')?.errors?.required">
                    {{ 'Client ID is required' | translate }}
                  </ng-container>
                  <ng-container *ngIf="settingGroup.get('client_id')?.errors?.whitespace">
                    {{ 'Client ID cannot contain only whitespace' | translate }}
                  </ng-container>
                </span>
              </div>

              <div class="form-field">
                <div class="form-input-container">
                  <span class="label">{{ 'Deployment ID' | translate }} *</span>
                  <input
                    type="text"
                    formControlName="deployment_id"
                    class="form-input"
                    [placeholder]="'Enter Deployment ID' | translate"
                    [class.invalid]="
                      settingGroup.get('deployment_id')?.invalid &&
                      settingGroup.get('deployment_id')?.touched
                    "
                  />
                </div>
                <span
                  class="error"
                  *ngIf="
                    settingGroup.get('deployment_id')?.invalid &&
                    settingGroup.get('deployment_id')?.touched
                  "
                >
                  <ng-container *ngIf="settingGroup.get('deployment_id')?.errors?.required">
                    {{ 'Deployment ID is required' | translate }}
                  </ng-container>
                  <ng-container *ngIf="settingGroup.get('deployment_id')?.errors?.whitespace">
                    {{ 'Deployment ID cannot contain only whitespace' | translate }}
                  </ng-container>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
